import { ApolloClient } from '@apollo/client'

import { trackOpenedChat } from '~/lib/analytics/actions/track'
import DriftApi from '~/lib/apis/DriftApi'

import sendPrivateMessageMutation from './mutation'
export const SHOW_CHAT = 'DRIFT/SHOW_CHAT'
export const DFM_FEEDBACK_CHAT = 'DRIFT/DFM_FEEDBACK_CHAT'
export const GET_PO_ENABLED_CHAT = 'DRIFT/GET_PO_ENABLED_CHAT'
export const GET_PREMIUM_ENABLED_CHAT = 'DRIFT/GET_PREMIUM_ENABLED_CHAT'
export const GET_TAX_EXEMPT_CHAT = 'DRIFT/GET_TAX_EXEMPT_CHAT'
export const TROUBLESHOOT_CHAT = 'DRIFT/TROUBLESHOOT_CHAT'
export const HTS_CODES_CHAT = 'DRIFT/HTS_CODES_CHAT'
export const FORM_5106_CHAT = 'DRIFT/FORM_5106_CHAT'
export const POISON_QUOTE_CHAT = 'DRIFT/POISON_QUOTE_CHAT'
export const REORDER_GENERAL_CHAT = 'DRIFT/REORDER_GENERAL_CHAT'
export const CONTACT_SALES_CHAT = 'DRIFT/CONTACT_SALES_CHAT'
export const ORDER_DETAILS_CHAT = 'DRIFT/ORDER_DETAILS_CHAT'
export const PLACE_DEPOSIT_CONTACT_CHAT = 'DRIFT/PLACE_DEPOSIT_CONTACT_CHAT'
export const VERIFY_SHIPPING_CHAT = 'DRIFT/VERIFY_SHIPPING_CHAT'
export const REQUEST_FREIGHT_SHIPPING_CHAT =
    'DRIFT/REQUEST_FREIGHT_SHIPPING_CHAT'
export const GET_ASSITANCE_FROM_FICTIV_CHAT =
    'DRIFT/GET_ASSITANCE_FROM_FICTIV_CHAT'
export const PRICE_MATCH_CHAT = 'DRIFT/PRICE_MATCH_CHAT'

type ApolloClientType = ApolloClient<object>

const DRIFT_ADMIN_USER_ID = '2090438'
const PLACE_DEPOSIT_CONTACT_CHAT_INTERACTION_ID = 274864
const VERIFY_SHIPPING_INTERACTION_ID = 276661
const REQUEST_FREIGHT_SHIPPING_CHAT_INTERACTION_ID = 280716
const GET_ASSITANCE_FROM_FICTIV_CHAT_INTERACTION_ID = 335191
const PRICE_MATCH_CHAT_INTERACTION_ID = 363810

export function openChatDrift() {
    return trackOpenedChat({
        type: SHOW_CHAT,
    })
}

export function openChatDriftTroubleShoot(quote_url?: string) {
    return trackOpenedChat({
        type: TROUBLESHOOT_CHAT,
        payload: {
            quote_url,
        },
    })
}

export function openChatDriftHTSCodes() {
    return trackOpenedChat({
        type: HTS_CODES_CHAT,
    })
}

export function openChatDriftForm5106() {
    return trackOpenedChat({
        type: FORM_5106_CHAT,
    })
}

export function openChatDriftPoisonQuote() {
    return trackOpenedChat({
        type: POISON_QUOTE_CHAT,
    })
}

export function openChatDriftDFMFeedback(quote_url?: string) {
    return trackOpenedChat({
        type: DFM_FEEDBACK_CHAT,
        payload: {
            quote_url,
        },
    })
}

export function openChatDriftContactSales(quote_name?: string) {
    return trackOpenedChat({
        type: CONTACT_SALES_CHAT,
        payload: {
            quote_name,
        },
    })
}

export function openChatDriftOrderDetails(order_id?: string) {
    return trackOpenedChat({
        type: ORDER_DETAILS_CHAT,
        payload: {
            order_id,
        },
    })
}

export function openChatDriftReorderGeneral(
    userId?: number,
    order_id?: string,
    client?: ApolloClientType,
    reorder_issue?: string,
) {
    return trackOpenedChat({
        type: REORDER_GENERAL_CHAT,
        payload: {
            userId,
            order_id,
            client,
            reorder_issue,
        },
    })
}

export function openChatGetPOEnabled() {
    return trackOpenedChat({
        type: GET_PO_ENABLED_CHAT,
    })
}

export function openChatGetPremiumEnabled() {
    return trackOpenedChat({
        type: GET_PREMIUM_ENABLED_CHAT,
    })
}

export function openChatGetTaxExempt() {
    return trackOpenedChat({
        type: GET_TAX_EXEMPT_CHAT,
    })
}

export function openChatPriceMatch() {
    return trackOpenedChat({
        type: PRICE_MATCH_CHAT,
    })
}

export function openChatGetAssistanceFromFictiv() {
    return trackOpenedChat({
        type: GET_ASSITANCE_FROM_FICTIV_CHAT,
    })
}

export function openChatDriftVerifyShipping({
    address,
    country,
    orderTotal,
    weight,
}: {
    address?: string
    country?: string
    orderTotal?: number | null
    weight?: number | null
}) {
    return trackOpenedChat({
        type: VERIFY_SHIPPING_CHAT,
        payload: { address, country, orderTotal, weight },
    })
}

export function openChatDriftRequestFreightShipping({
    address,
    weight,
}: {
    address?: string
    weight?: number
}) {
    return trackOpenedChat({
        type: REQUEST_FREIGHT_SHIPPING_CHAT,
        payload: { address, weight },
    })
}

export function driftMiddleware(driftApi: DriftApi) {
    const HANDLERS: {
        [key: string]: Function
    } = {
        [SHOW_CHAT]: ({
            payload: { chat_message } = {},
        }: {
            payload?: {
                chat_message?: string
            }
        }) => {
            driftApi.setUserAttributes({
                chat_message,
            })
            driftApi.startInteraction({
                interactionId: 202510,
            })
        },
        [TROUBLESHOOT_CHAT]: ({
            payload: { quote_url } = {},
        }: {
            payload?: {
                quote_url?: string
            }
        }) => {
            driftApi.setUserAttributes({
                quote_url,
            })
            driftApi.startInteraction({
                interactionId: 203755,
            })
        },
        [POISON_QUOTE_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: 203416,
            })
        },
        [HTS_CODES_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: 203696,
            })
        },
        [FORM_5106_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: 203706,
            })
        },
        [DFM_FEEDBACK_CHAT]: ({
            payload: { quote_url } = {},
        }: {
            payload?: {
                quote_url?: string
            }
        }) => {
            driftApi.setUserAttributes({
                quote_url,
            })
            driftApi.startInteraction({
                interactionId: 201352,
            })
        },
        [GET_PO_ENABLED_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: 270337,
            })
        },
        [GET_PREMIUM_ENABLED_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: 348431,
            })
        },
        [GET_TAX_EXEMPT_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: 347296,
            })
        },
        [PRICE_MATCH_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: PRICE_MATCH_CHAT_INTERACTION_ID,
            })
        },
        [CONTACT_SALES_CHAT]: ({
            payload: { quote_name } = {},
        }: {
            payload?: {
                quote_name?: string
            }
        }) => {
            driftApi.setUserAttributes({
                quote_name,
            })
            driftApi.startInteraction({
                interactionId: 219340,
            })
        },
        [ORDER_DETAILS_CHAT]: ({
            payload: { order_id } = {},
        }: {
            payload?: {
                order_id?: string
            }
        }) => {
            driftApi.setUserAttributes({
                order_id,
            })
            driftApi.startInteraction({
                interactionId: 219363,
            })
        },
        [REORDER_GENERAL_CHAT]: ({
            payload: { order_id, client, reorder_issue } = {},
        }: {
            payload?: {
                order_id?: string
                reorder_issue?: string
                client?: ApolloClientType
            }
        }) => {
            driftApi.setUserAttributes({
                order_id,
            })
            driftApi.startInteraction({
                interactionId: 201394,
            })

            if (reorder_issue && client) {
                driftApi.on('startConversation', async function (x: any) {
                    const conversationId = x.conversationId.toString()

                    await client.mutate({
                        mutation: sendPrivateMessageMutation,
                        variables: {
                            message: reorder_issue,
                            conversationId,
                            userId: DRIFT_ADMIN_USER_ID,
                        },
                    })
                    reorder_issue = undefined
                })
            }
        },
        [PLACE_DEPOSIT_CONTACT_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: PLACE_DEPOSIT_CONTACT_CHAT_INTERACTION_ID,
            })
        },
        [GET_ASSITANCE_FROM_FICTIV_CHAT]: () => {
            driftApi.startInteraction({
                interactionId: GET_ASSITANCE_FROM_FICTIV_CHAT_INTERACTION_ID,
            })
        },
        [VERIFY_SHIPPING_CHAT]: ({
            payload: { address, country, orderTotal, weight } = {},
        }: {
            payload?: {
                address?: string
                country?: string
                orderTotal?: number
                weight?: number
            }
        }) => {
            driftApi.setUserAttributes({
                last_intl_order_address: address,
                last_intl_order_shipping_country: country,
                last_intl_order_amount: (orderTotal || 0) / 100,
                last_intl_order_weight: weight,
            })
            driftApi.startInteraction({
                interactionId: VERIFY_SHIPPING_INTERACTION_ID,
            })
        },
        [REQUEST_FREIGHT_SHIPPING_CHAT]: ({
            payload: { address, weight } = {},
        }: {
            payload?: {
                address?: string
                weight?: number
            }
        }) => {
            driftApi.setUserAttributes({
                last_order_shipping_address_freight_ship: address,
                last_order_freight_ship_weight: weight,
            })
            driftApi.startInteraction({
                interactionId: REQUEST_FREIGHT_SHIPPING_CHAT_INTERACTION_ID,
            })
        },
    }

    return () => (next: Function) => (action: { type: string }) => {
        if (HANDLERS[action.type]) {
            HANDLERS[action.type](action)
        }
        return next(action)
    }
}
